import React from 'react';
import Seo from '../components/Seo';
import { PORTAL_URL, IMAGES } from '../mock';

const PatientPortal = () => {
  return (
    <div>
      <Seo
        title="Patient Portal Login"
        description="Log into the secure TherapyAppointment patient portal for The Mood & Sleep Clinic to manage appointments, messages, and billing."
        path="/patient-portal"
      />
      <div className="h-24 sm:h-32 w-full bg-cover bg-center" style={{ backgroundImage: `url(${IMAGES.waterBanner})` }} />
      <section className="bg-sky-band">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <h1 className="font-heading font-light text-navy text-3xl sm:text-4xl md:text-5xl tracking-wide fade-up">Log Into Your Patient Portal</h1>
          <p className="mt-3 text-navy/70 text-lg">Please use this link to access the patient portal.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-md mx-auto px-4">
          <div className="bg-white rounded-2xl border border-border shadow-sm p-10 text-center">
            <div className="w-20 h-20 mx-auto rounded-full bg-secondary flex items-center justify-center">
              <img src="/door-icon.png" alt="Open door icon representing access to your patient portal" className="w-11 h-11 object-contain" width="44" height="44" />
            </div>
            <h2 className="mt-6 font-heading text-xl text-navy">Secure Patient Portal</h2>
            <p className="mt-3 text-muted-foreground">
              Access your appointments, secure messages, and billing through the TherapyAppointment portal.
            </p>
            <a
              href={PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 rounded-full border-2 border-navy text-navy px-10 py-3 font-heading font-medium hover:bg-navy hover:text-white transition-colors"
            >
              Patient Portal
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PatientPortal;
